
import * as export0 from "/opt/build/repo/packages/dsi-logo-maker/functions/fillAnimatedCanvas/index.js";
import * as export1 from "/opt/build/repo/packages/dsi-logo-maker/functions/fillAnimatedSVG/index.js";
import * as export2 from "/opt/build/repo/packages/dsi-logo-maker/functions/fillCanvas/index.js";
import * as export3 from "/opt/build/repo/packages/dsi-logo-maker/functions/fillSVG/index.js";
import * as export4 from "/opt/build/repo/packages/dsi-logo-maker/functions/flagBuilderCanvas/index.js";
import * as export5 from "/opt/build/repo/packages/dsi-logo-maker/functions/flagBuilderSVG/index.js";
import * as export6 from "/opt/build/repo/packages/dsi-logo-maker/functions/logoAnimatedCanvas/index.js";
import * as export7 from "/opt/build/repo/packages/dsi-logo-maker/functions/logoAnimatedSVG/index.js";
import * as export8 from "/opt/build/repo/packages/dsi-logo-maker/functions/logoCanvas/index.js";
import * as export9 from "/opt/build/repo/packages/dsi-logo-maker/functions/logoSVG/index.js";
import * as export10 from "/opt/build/repo/packages/dsi-logo-maker/functions/pinSVG/index.js";
import * as export11 from "/opt/build/repo/packages/dsi-logo-maker/functions/playCanvas/index.js";
import * as export12 from "/opt/build/repo/packages/dsi-logo-maker/functions/playSVG/index.js";
import * as export13 from "/opt/build/repo/packages/dsi-logo-maker/functions/textAndImageCanvas/index.js";
import * as export14 from "/opt/build/repo/packages/dsi-logo-maker/functions/textAndImageSVG/index.js";
import * as export15 from "/opt/build/repo/packages/dsi-logo-maker/functions/textAnimatedCanvas/index.js";
import * as export16 from "/opt/build/repo/packages/dsi-logo-maker/functions/textCanvas/index.js";


const allFunctions = {
  "fillAnimatedCanvas": export0,
"fillAnimatedSVG": export1,
"fillCanvas": export2,
"fillSVG": export3,
"flagBuilderCanvas": export4,
"flagBuilderSVG": export5,
"logoAnimatedCanvas": export6,
"logoAnimatedSVG": export7,
"logoCanvas": export8,
"logoSVG": export9,
"pinSVG": export10,
"playCanvas": export11,
"playSVG": export12,
"textAndImageCanvas": export13,
"textAndImageSVG": export14,
"textAnimatedCanvas": export15,
"textCanvas": export16
};

const functions = Object.fromEntries(
  Object.entries(allFunctions).filter(([name, func]) => !func.settings.hideFunction)
);

export default functions;
